import { Component } from '@angular/core';
import { DeviceCreateService } from 'src/app/core/services/device-create.service';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrl: './devices.component.scss'
})
export class DevicesComponent {
  serialNumberInput = '';
  showAddDeviceModal = false;
  showEditDeviceModal = false;
  showAddDeviceFab = true;

  deviceToEdit: any = {
    deviceName: '',
    serialNumber: '',
  };
 constructor(private deviceService: DeviceCreateService) {}
  //deviceTypes = ['Ventilator', 'Monitor', 'Infusion Pump', 'CPAP', 'Other'];
  selectedStatus = 'Active';

  addDevice() {
    this.showAddDeviceModal = true;
  }

  openAddDeviceModal() {
    this.deviceToEdit = {};
    this.selectedStatus = 'Active';
    this.showAddDeviceModal = true;
  }

  closeAddDeviceModal() {
    this.showAddDeviceModal = false;
  }

  openEditDeviceModal(device: any) {
    this.deviceToEdit = { ...device };
    this.selectedStatus = device.status;
    this.showEditDeviceModal = true;
  }

  closeEditDeviceModal() {
    this.showEditDeviceModal = false;
  }

  setStatus(status: string) {
    this.selectedStatus = status;
    this.deviceToEdit.status = status;
  }

  saveNewDevice() {
  console.log('Serial number from UI:', this.deviceToEdit.serialNumber); // debug
  this.deviceService.createDevice(this.deviceToEdit.serialNumber).subscribe({
    next: (res) => {
      console.log('New device saved successfully:', res);
      this.closeAddDeviceModal();
    },
    error: (err) => {
      console.error('Error saving device:', err);
    }
  });
}

  saveDeviceEdit() {
    console.log('Device updated:', this.deviceToEdit);
    this.closeEditDeviceModal();
  }
}
